import { EventEmitter, Injectable } from '@angular/core';
import { IModalOptions } from "../../common/modals/modal-options.interface";
import { YesNoModalOptions } from "../../common/modals/yesno-modal-options.class";
import { EcaConfirmModalComponent } from "../components/eca-confirm-modal/eca-confirm-modal.component";
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';

@Injectable({
  providedIn: 'root'
})

export class EcaConfirmProcessService {
  modalRef: IEcaDialogRef;

  constructor(private modalService: EcaDynamicModalService) { }

  openConfirmProcessModal(
    question: string,
    heading: string,
    options?: IModalOptions): EventEmitter<boolean> {
    if (options === undefined) {
      options = new YesNoModalOptions();
    }

    let config = {
      styleClass: 'modal-notify' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      data: {
        question,
        heading,
        yesButtonText: options.yesButtonText,
        noButtonText: options.noButtonText,
        yesButtonColour: options.yesButtonColour,
        noButtonColour: options.noButtonColour,
        yesButtonIcon: options.yesButtonIcon,
        noButtonIcon: options.noButtonIcon,
      }
    } as DynamicDialogConfig;

    this.modalRef = this.modalService.openDialog(EcaConfirmModalComponent, config);
    return this.modalRef.content.answer;
  }
}
